import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { educationModuleContextSchema } from '@entities/education-module';
import { StudentEducationModulePage } from '@pages/student';
import type { RouterContext } from '@shared/config/router-context';
import { canAccessPersonalFlow } from '@shared/lib';

export const educationModuleSearchSchema = z.object({
  profileRef: z.string().min(1),
  contextKind: educationModuleContextSchema.shape.kind,
  contextId: z.string().min(1),
  mode: z.enum(['resume', 'review']).catch('resume'),
  slideId: z.string().min(1).optional().catch(undefined),
  emLogId: z.string().min(1).optional().catch(undefined),
});

export const Route = createFileRoute('/$locale/_authenticated/student/education/modules/$moduleId')(
  {
    component: StudentEducationModuleRoute,
    validateSearch: educationModuleSearchSchema,
    beforeLoad: ({ context, params }) => {
      const routerContext = context as RouterContext;
      if (
        !routerContext.auth.isLoading &&
        !canAccessPersonalFlow(routerContext.ability, routerContext.auth.user?.id ?? null)
      ) {
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        throw redirect({ to: '/$locale/unauthorized', params: { locale: params.locale } });
      }
    },
  }
);

function StudentEducationModuleRoute() {
  const { locale, moduleId } = Route.useParams();
  const { profileRef, contextKind, contextId, mode, slideId, emLogId } = Route.useSearch();
  return (
    <StudentEducationModulePage
      locale={locale}
      mode={mode}
      target={{
        profile_ref: profileRef,
        module_id: moduleId,
        context: { kind: contextKind, id: contextId },
        ...(slideId === undefined ? {} : { initial_slide_id: slideId }),
        ...(emLogId === undefined ? {} : { em_log_id: emLogId }),
      }}
    />
  );
}
